import React, { useState, useContext, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../../AppContext";
import * as actions from "../../actions/actions";
import Service from "../../services/service";
import LibraryTitle from '../../components/libraryTitleBar';
import LoadingScreen from '../../components/LoadingScreen.js';
import Pagination from '../../components/pagination';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Table from '../../components/table';
import Checkbox from '@material-ui/core/Checkbox';
import { timeConverter, getModuloColor } from '../../helpers/constants';
import { Paper, Link, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import LibraryDetails from '../../components/LibraryDetails';
import SearchIcon from '@material-ui/icons/Search';
import NewProjectForm from '../../components/NewProjectForm';
import IconLabel from '../../components/IconLabel';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
    },
    title: {
        flex: "0 0 auto",
        height: 0,
    },
    body_container: {
        display: 'flex',
        flex: '1',
        flexDirection: 'row',
        position: "relative",
    },
    content: {
        position: "relative",
        flex: "1 1 auto",
        overflow: "hidden",
        overflowY: "auto",    // FIXME, showing temp scroll bar during loading in table vview
        padding: 0,
        height: 0,  // no clue why this is required, but omitting won't display a vertical scroll bar
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignContent: "flex-start",
    },
    bottom: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 'auto',
        padding: '10px 10px 10px 15px',
        height: '43px',
        borderTop: "1px solid #dddddd",
    },
    item: {
        width: "33%",
        [theme.breakpoints.down('md')]: {
            width: "50%",
        },
        padding: theme.spacing(1),
        height: "150px"
    },
    pagination: {
        marginLeft: 'auto'
    },
    resultWidth: {
        width: '150px',
        backgroundColor: '#455641'
    },
    paper: {
        display: "flex",
        flex: "1 1 0",
        minHeight: 0,
        margin: 10,
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.1)",
        zIndex: 2,
        flexDirection: 'column',
        position: "relative"
    },
    paperwithOutBackground: {
        background: 'transparent',
        boxShadow: 'none',
        margin: 0,
        display: "flex",
        flex: "1 1 0",
        minHeight: 0,
        zIndex: 2,
        flexDirection: 'column',
        position: "relative"
    },
    checkIcon: {
        color: 'green'
    },
    errorIcon: {
        color: 'red',
    },
    clockIcon: {
        color: 'black'
    },
    cacheIcon: {
        color: 'grey'
    },
    errorBox: {
        color: 'red'
    },
    table_preview_header: {
        width: '65px',
        textAlign: "center",
    },
    table_result_header: {
        width: '65px',
        textAlign: "center",
        cursor: "zoom-in"
    },
    table_action_header: {
        width: '120px',
        textAlign: 'center'

    },
    table_title_header: {
        width: "60%",
        minWidth: "100px",
    },
    table_project_header: {
        width: '20%',
        minWidth: "100px",
        padding: "0 5px",
    },
    table_library_header: {
        width: '20%',
        minWidth: "100px",
    },
    projectTag: {
        backgroundColor: getModuloColor(1),
        borderRadius: 3,
        paddingLeft: 5,
        paddingRight: 5,
        flex: "0 0 auto",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    table_credits_header: {
        width: '60px',
        textAlign: "center",
        cursor: "default",
    },
    table_status_header: {
        width: '50px',
        textAlign: "center",
    },
    table_source_header: {
        width: '80px',
        textAlign: "center",
    },
    table_date_header: {
        width: '120px',
        cursor: "default",
    },
    reportContainerSize: {
        minWidth: (state) => {
            return state.loadingSource ? '320px' : '25%';
        },
        width: '25%',
        maxWidth: '25%',
        backgroundColor: '#ffffff',
        // opacity: 0.7,
    },
    overlay: {
        zIndex: "99",
        right: "0px",
        top: "0",
        left: "0",
        bottom: "0",
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        backgroundColor: "rgba(0,0,0,0.6)",
    },
    helper_container: {
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        zIndex: -1,
        opacity: 1,
        transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        position: "fixed",
        alignItems: "center",
        touchAction: "none",
        justifyContent: 'center',
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        webkitTapHighlightColor: "transparent",
    },
    reportStatusContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 1,
        transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        color: '#FFFFFF'
    },
    centerAlign: {
        textAlign: "center"
    },
    resultReportPercent: {
        fontSize: "12px",
        fontWeight: "800",
        display: "block",
        marginTop: "-21px",
    },
    marginFix: {
        marginBottom: "-2px"
    },
    table_project_cell: {
        display: "flex",
        overflow: "hidden",
    }
}))

export default function LibraryOverviewComponent(props) {
    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles(state);
    const [librariesLoading, setLibrariesLoading] = useState(false);

    useEffect(() => {
        dispatch(actions.setUI({ libraryMenuExpanded: true }));
        loadLibraries();
    }, [state.librariesChangeNo]);

    if (window && window.location && state.ui && state.ui.pageName !== window.location.pathname) {
        dispatch(actions.navigate_to(window.location.pathname));
    }

    function loadLibraries() {
        setLibrariesLoading(true);
        Service.getLibraries({ filters: state.libraryFilter, ...state.libraryPagination, pagesize: state.user.settings.pagesize }).then(res => {
            if (res.success) {
                setLibrariesLoading(false);
                dispatch(actions.setLibtexts(res || []))
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });

        if (state.activeLibraryId) {
            Service.getLibrary(state.activeLibraryId).then(res => {
                dispatch(actions.get_library(res.data || []));
            });
        }
    }

    const onSelectId = (libraryID, e) => {
        dispatch(actions.navigate_to("/plagiarism/reports/" + libraryID));
        dispatch(actions.change_library_card(libraryID));
    }

    const onChangePage = (page, pageLength) => {
        dispatch(actions.change_library_pagination({
            ...state.libraryPagination,
            pagesize: pageLength,
            pageno: page
        }));
    }

    const columns = useMemo(() => [
        {
            Header: ({ getToggleAllRowsSelectedProps }) => <Checkbox size="small" {...getToggleAllRowsSelectedProps()} />,
            accessor: "Active",
            Cell: ({ row }) => <Checkbox size="small" onClick={(e) => e.stopPropagation()} {...row.getToggleRowSelectedProps()} />,
            headerClassName: classes.table_status_header,
            cellClassName: classes.table_status_header,
            disableSortBy: true,
        },
        {
            Header: s.date,
            accessor: "Date",
            Cell: ({ cell: { value } }) => <>{timeConverter(value, 'time')}</>,
            headerClassName: classes.table_date_header,
            cellClassName: classes.table_date_header,
        },
        {
            Header: s.name,
            accessor: "Name",
            cellClassName: classes.table_title_header,
            headerClassName: classes.table_title_header,
            Cell: ({ cell: { value, row } }) => <Link style={{ cursor: "pointer" }} href={"/libtext/" + row.original.Id} target="_blank">{value}</Link>
        },
        {
            Header: s.project,
            accessor: "ProjectName",
            headerClassName: classes.table_project_header,
            cellClassName: classes.table_project_header,
            Cell: ({ cell: { value, row } }) => <div className={classes.table_project_cell}><div style={{ backgroundColor: getModuloColor(row.original.ProjectId) }} className={classes.projectTag}>{value}</div></div>,
        },
        {
            Header: s.words,
            accessor: "Words",
            headerClassName: classes.table_credits_header,
            cellClassName: classes.table_credits_header,
        },
        {
            Header: s.pages,
            accessor: "Pages",
            headerClassName: classes.table_credits_header,
            cellClassName: classes.table_credits_header,
        },
        {
            Header: s.libraryOverview.fulltext,
            accessor: "Fingerprint",
            headerClassName: classes.table_credits_header,
            cellClassName: classes.table_credits_header,
            Cell: ({ cell: { value, row } }) => <>{value ? <FingerprintIcon data-for="globalTT" data-tip={s.libraryOverview.fingerprintTip} /> : <DescriptionOutlinedIcon data-for="globalTT" data-tip={s.libraryOverview.fulltextTip}/> }</>,        
        },
        {
            Header: s.actions,
            accessor: s.actions,
            headerClassName: classes.table_action_header,
            cellClassName: classes.table_action_header,
            disableSortBy: true,
            Cell: ({ cell: { value, row } }) =>
                <div>
                    <IconButton disabled={row.original.Fingerprint} data-for="globalTT" data-tip={s.libraryOverview.performCheckOnThis} size="small" onClick={(e) => onMagnifyRow(e, row.original)}>
                        <SearchIcon />
                    </IconButton>
                    <IconButton data-for="globalTT" data-tip={s.libraryOverview.deleteThisTip} size="small"
                        onClick={(e) => onDeleteLibrary(e, row.original)} disabled={(row.original.Status !== "Ok" && row.original.Status !== "Error")}>
                        <DeleteForeverIcon />
                    </IconButton>
                </div>,
        },
    ], [s.date] // react on language change in order to reflect new date format
    );

    const onDeleteLibrary = (e, row) => {
        e && e.stopPropagation();
        dispatch(actions.openConfirmationDialog({
            title: s.libraryOverview.deleteText,
            text: s.libraryOverview.deleteTextDesc,
            onConfirm: () => deleteLibraries([row.Id])
        }));
    }

    const deleteMultipleRow = () => {
        dispatch(actions.openConfirmationDialog({
            title: s.libraryOverview.deleteTexts.format(state.selectedLibraryIds.length),
            text: s.libraryOverview.deleteTextsDesc,
            onConfirm: () => deleteLibraries(state.selectedLibraryIds)
        }));
    }

    const magnifyMultipleRow = () => {
        let data = state.libraries.filter((item) => {
            return state.selectedLibraryIds.includes(item.Id);
        });
        dispatch(actions.setNewCheckSettings({ source: 'library', libraryTexts: data }));
        dispatch(actions.navigate_to('/plagiarism/new'));
    }

    const fingerprintMultipleRow = () => {
        dispatch(actions.openConfirmationDialog({
            title: s.libraryOverview.performFingerprintOnSelectedTitle,
            text: s.libraryOverview.performFingerprintOnSelectedDesc.format(nonFingerPrintTextsSelected().length),
            onConfirm: () => onConfirmFingerprint()
        }));
    }

    const onMagnifyRow = (e, row) => {
        e && e.stopPropagation();
        dispatch(actions.setNewCheckSettings({ source: 'library', libraryTexts: [row] }));
        dispatch(actions.navigate_to('/plagiarism/new'));
    }

    const deleteLibraries = (libraryids) => {
        Service.deleteLibraries(libraryids).then(res => {
            if (res && res.success) {
                dispatch(actions.notifyLibrariesChanged());
                dispatch(actions.openToast({ type: "success", message: s.notificationMessage.libtextsDeleted.format(res.total), status: true }));
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }
    const onConfirmFingerprint = () => {
        // providing dummy values for date and title to satisfy CommandDispatcher. Thes will be ignored because they're filtered out by field set to fingerprint
        nonFingerPrintTextsSelected().length && Service.UpdateLibraries({fingerprint: 1, field: 'fingerprint', date:'200-01-01', title: 'dummy' }, nonFingerPrintTextsSelected()).then(res => {
          if (res.success) {
              dispatch(actions.notifyLibrariesChanged());
              dispatch(actions.openToast({ type: "success", message: s.notificationMessage.libtextsChangedToFingerprint.format(res.total), status: true }));
          } else {
            dispatch(actions.openToast({ type: "false", message: res.errors[0], status: true }));
          }
        });
      }


    // handle active row changed
    const onActiveRowHandle = async (rowDetails, index) => {
        if (rowDetails) {
            dispatch(actions.setActiveLibrary(rowDetails.Id));       // immediate feedback to table 
            await Service.getLibrary(rowDetails.Id).then(res => {    // load details for new active report, this updates the details panel
                dispatch(actions.get_library(res.data || []));
            });
        } else {
            dispatch(actions.setActiveLibrary(null));
        }
    }

    const rowSelectedHandle = (rows) => {
        dispatch(actions.changeLibrarySelection(rows.map(r => r.Id)));
    }

    const handleSort = (sortBy) => {
        const sortByDetails = sortBy[0] || {
            id: 'Date',
            desc: true
        }
        const libraryFilter = {
            ...state.libraryPagination,
            sortby: sortByDetails.id,
            sortdir: sortByDetails.desc === true ? 'desc' : 'asc'
        }
        dispatch(actions.change_library_pagination(libraryFilter));
    }

    const nonFingerPrintTextsSelected = () => (state.libraries.filter((lib) => { 
        return (state.selectedLibraryIds.includes(lib.Id)) && (lib.Fingerprint == 0)
    }).map(lib => lib.Id));


    return (
        <div className={classes.root}>
            {state.openCreateProjectPopup && <NewProjectForm />}
            <LibraryTitle className={classes.title} title={s.library} type="LibraryOverview" />
            <div className={classes.body_container}>
                <Paper elevation={3} className={state.performCheckLayout === 'list' ? classes.paper : classes.paperwithOutBackground}>
                    <LoadingScreen status={librariesLoading} />
                    <div className={classes.content}>
                        {state.libraries.length > 0 ?
                            <Table
                                data={state.libraries}
                                onSelectedRowsChange={rowSelectedHandle}
                                selectedIds={state.selectedLibraryIds}
                                columns={columns}
                                onActiveRowChanged={onActiveRowHandle}
                                activeRowId={state.activeLibraryId}
                                onSort={handleSort}
                                onSortBy={state.libraryPagination}
                            />
                            : (!librariesLoading && <IconLabel centered label={s.libraryOverview.noLibtextsFound} spacing={32} />)
                        }
                    </div>

                    <div className={classes.bottom}>

                        {state.selectedLibraryIds.length > 0 &&
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Typography variant="body2" color="primary">{s.libraryOverview.selectedTexts.format(state.selectedLibraryIds.length)}</Typography>
                                <IconButton disabled={ (nonFingerPrintTextsSelected().length > 0) ? false : true } data-for="globalTT" data-tip={s.libraryOverview.performCheckOnSelected} style={{ marginLeft: 8 }} size="small" onClick={magnifyMultipleRow}><SearchIcon /></IconButton>
                                <IconButton disabled={ (nonFingerPrintTextsSelected().length > 0) ? false : true } data-for="globalTT" data-tip={s.libraryOverview.performFingerprintOnSelected} size="small" onClick={fingerprintMultipleRow}><FingerprintIcon /></IconButton>
                                <IconButton data-for="globalTT" data-tip={s.libraryOverview.deleteSelectedTip} size="small" onClick={deleteMultipleRow}> <DeleteForeverIcon /></IconButton>
                            </div>
                        } 

                        <div className={classes.pagination}>
                            <Pagination
                                page={state.libraryPagination.pageno}
                                pageLength={state.user.settings.pagesize}
                                totalRecords={state.totalLibrariesNumber || 0}
                                onchange={onChangePage}
                            />
                        </div>
                    </div>
                </Paper>
                <div className={classes.reportContainerSize}  >
                    <LibraryDetails view={true} />
                </div>
            </div>
        </div>
    )
}